export default __webpack_public_path__ + "static/media/05.ab228ca6.jpg";